export default "__VITE_ASSET__DJX3lHKm__"